import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router";

const TrailingSlashRedirect = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const { pathname, search, hash } = location;

    if (pathname.length > 1 && pathname.endsWith("/")) {
      navigate(
        {
          pathname: pathname.replace(/\/+$/, ""),
          search,
          hash,
        },
        { replace: true }
      );
    }
  }, [location, navigate]);

  return null;
};

export default TrailingSlashRedirect;
